import { render } from "./ParcoursMain.vue?vue&type=template&id=0efeb598"
import script from "./ParcoursMain.vue?vue&type=script&lang=js"
export * from "./ParcoursMain.vue?vue&type=script&lang=js"

import "./ParcoursMain.vue?vue&type=style&index=0&id=0efeb598&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__